import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';
import moment from 'moment';
import { appId } from '@/config/index.js';
import { getDevice } from '@/utils/getdevice.js';
import { getAccessToken, getUserInfo } from '@/api/account';
import { wxConfig } from '@/utils/wxinit';
import { reportLoginPlatform, reportLoginForum } from '@/api/report';
import { Dialog } from 'vant';
import { isWeiXin } from '@/utils';

Vue.use(Router);
const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    // ———————————————————————————————————— 黑喵论坛页面 ———————————————————————————————————————
    // 游戏圈
    {
      path: '/gameCircle',
      name: 'gameCircle',
      component: () => import('@/views/gameCircle/index.vue'),
      children: [
        // 游戏圈帖子列表页
        {
          path: 'home',
          name: 'gameCircle.home',
          component: () => import('@/views/gameCircle/home.vue'),
          meta: { title: '游戏圈', bottomNav: true, keepAlive: true, isBack: false },
        },
        // 帖子详情页
        {
          path: 'details',
          name: 'gameCircle.details',
          component: () => import('@/views/gameCircle/details.vue'),
          meta: { title: '帖子详情' },
        },
      ],
    },
    // ———————————————————————————————————— 黑喵平台页面 ———————————————————————————————————————
    // 论坛注册页
    {
      path: '/account/registeredAccount',
      name: 'account.registeredAccount',
      component: () => import('@/views/account/registeredAccount.vue'),
    },
    // 游戏圈中心页
    {
      path: '/gameCircleCenter',
      name: 'gameCircleCenter',
      component: () => import('@/views/gameCircleCenter/index.vue'),
      children: [
        {
          path: 'home',
          name: 'gameCircleCenter.home',
          component: () => import('@/views/gameCircleCenter/home.vue'),
          meta: { title: '游戏圈中心', bottomNav: true },
        },
      ],
    },
    // 个人主页
    {
      path: '/personalCenter',
      name: 'personalCenter',
      component: () => import('@/views/personalCenter/index.vue'),
      children: [
        {
          path: 'home',
          name: 'personalCenter.home',
          component: () => import('@/views/personalCenter/home.vue'),
          meta: { title: '个人主页', bottomNav: true },
        },
        {
          path: 'modifyInfo',
          name: 'personalCenter.modifyInfo',
          component: () => import('@/views/personalCenter/modifyInfo.vue'),
          meta: { title: '黑喵精灵', bottomNav: true },
        },
        {
          path: 'myNews',
          name: 'personalCenter.myNews',
          component: () => import('@/views/personalCenter/myNews.vue'),
          meta: { title: '我的消息', bottomNav: true },
        },
        {
          path: 'myGift',
          name: 'personalCenter.myGift',
          component: () => import('@/views/personalCenter/myGift.vue'),
          meta: { title: '我的礼包', bottomNav: true },
        },
      ],
    },
    // 论坛公告页面
    {
      path: '/account/announcement',
      name: 'account.announcement',
      component: () => import('@/views/account/announcement.vue'),
    },
    // 游戏中心页
    {
      path: '/gameCenter',
      name: 'gameCenter',
      redirect: '/gameCenter/home',
      component: () => import('@/views/gameCenter/index.vue'),
      children: [
        {
          path: 'home',
          name: 'gameCenter.home',
          component: () => import('@/views/gameCenter/home2.vue'),
          meta: { title: '游戏中心', bottomNav: true, suspend: 1 },
        },
      ],
    },
    // 礼包中心页
    {
      path: '/giftCenter',
      name: 'giftCenter',
      redirect: '/giftCenter/home',
      component: () => import('@/views/giftCenter/index.vue'),
      children: [
        {
          path: 'home',
          name: 'giftCenter.home',
          component: () => import('@/views/giftCenter/home.vue'),
          meta: { title: '礼包中心', keepAlive: true, suspend: 2 },
        },
        {
          path: 'details',
          name: 'giftCenter.details',
          component: () => import('@/views/giftCenter/details.vue'),
          meta: { title: '礼包详情' },
        },
        {
          path: 'activatedGame',
          name: 'giftCenter.activatedGame',
          component: () => import('@/views/giftCenter/activatedGame.vue'),
          meta: { title: '已激活游戏' },
        },
        {
          path: 'allGift',
          name: 'giftCenter.allGift',
          component: () => import('@/views/giftCenter/allGift.vue'),
          meta: { title: '全部礼包' },
        },
      ],
    },
    // 活动页
    {
      path: '/activity',
      name: 'activity',
      component: () => import('@/views/activity/index.vue'),
      children: [
        {
          // 签到有礼活动
          path: 'signGift',
          name: 'activity.signGift',
          component: () => import('@/views/activity/signGift.vue'),
          meta: { title: '签到有礼' },
        },
        {
          // 代金券
          path: 'vouchers',
          name: 'activity.vouchers',
          component: () => import('@/views/activity/vouchers.vue'),
          meta: { title: '代金券', bottomNav: true },
        },
        {
          // 活动跳转页面
          path: 'authorization',
          name: 'activity.authorization',
          component: () => import('@/views/activity/authorization.vue'),
          meta: { title: '代金券大回馈' },
        },
        {
          // 秒杀活动
          path: 'seckill',
          name: 'activity.seckill',
          component: () => import('@/views/activity/seckill.vue'),
          redirect: (to) => {
            const seckillActHost = ['hm.yuwanf.com', 'hm.hnyuezan7.cn'];
            if (seckillActHost.includes(window.location.hostname)) {
              return 'seckillAct';
            } else {
              return 'authorization';
            }
          },
          meta: { title: '代金券大回馈' },
        },
        {
          // 秒杀活动真实路径
          path: 'seckillAct',
          name: 'activity.seckillAct',
          component: () => import('@/views/activity/seckill.vue'),
          meta: { title: '代金券大回馈' },
        },
        {
          // 秒杀活动规则页面
          path: 'seckillRules',
          name: 'activity.seckillRules',
          component: () => import('@/views/activity/components/seckill/seckillRules.vue'),
          meta: { title: '代金券大回馈' },
        },
        {
          // 代金券使用教程页面
          path: 'userGuidance',
          name: 'activity.userGuidance',
          component: () => import('@/views/activity/components/seckill/userGuidance.vue'),
          meta: { title: '代金券大回馈' },
        },
        {
          // 871帝王荣耀签到抽奖活动
          path: 'imperialGlory',
          name: 'activity.imperialGlory',
          component: () => import('@/views/activity/imperialGlory.vue'),
          meta: { title: '帝王荣耀签到抽奖' },
        },
        {
          // 947逍遥三国拉收活动
          path: 'freeKingdoms',
          name: 'activity.freeKingdoms',
          component: () => import('@/views/activity/freeKingdoms.vue'),
          meta: { title: '逍遥三国' },
        },
        {
          // 1001傲世龙城平台活动
          path: 'dragonCity',
          name: 'activity.dragonCity',
          component: () => import('@/views/activity/dragonCity.vue'),
          meta: { title: '傲世龙城' },
        },
        {
          // 2025.07.02 转游开红包
          path: 'retourGame',
          name: 'activity.retourGame',
          component: () => import('@/views/activity/retourGame.vue'),
          meta: { title: '转游开红包' },
        },
      ],
    },
    // 通过黑喵获取微信信息进入工单页
    {
      path: '/worker-sn',
      name: 'worker.sn',
      component: () => import('@/views/workerSn/index.vue'),
    },
    // 2011.11.16新增 预览圈子和帖子详情页面 - 可在浏览器中打开 绕过微信授权逻辑 只可查看 不可发帖、不可点赞等
    {
      path: '/preview',
      name: 'preview',
      component: () => import('@/views/preview/index.vue'),
      children: [
        // {
        //   path: 'home',
        //   name: 'preview.home',
        //   component: () => import('@/views/preview/home.vue'),
        //   meta: { title: '游戏圈', bottomNav: false, keepAlive: true, isBack: false },
        // },
        {
          path: 'details',
          name: 'preview.details',
          component: () => import('@/views/preview/details.vue'),
          meta: { title: '帖子详情' },
        },
        {
          path: '996',
          name: 'preview.996',
          component: () => import('@/views/preview/996.vue'),
          meta: { title: '变态猫—996游戏推荐福利官' },
        },
      ],
    },
    // 太古商城
    {
      path: '/tgStore',
      name: 'tgStore',
      component: () => import('@/views/tgStore/index.vue'),
      children: [
        {
          path: 'store',
          name: 'tgStore.store',
          component: () => import('@/views/tgStore/store.vue'),
          meta: { title: '伏妖记-道具商城', allowNoAuth: true },
        },
        {
          path: 'cutUserStore',
          name: 'tgStore.cutUserStore',
          component: () => import('@/views/tgStore/cutUserStore.vue'),
          meta: { title: '伏妖记-道具商城', allowNoAuth: true },
        },
        {
          path: 'pay',
          name: 'tgStore.pay',
          component: () => import('@/views/tgStore/pay.vue'),
          meta: { title: '支付', allowNoAuth: true },
        },
        {
          path: 'record',
          name: 'tgStore.record',
          component: () => import('@/views/tgStore/record.vue'),
          meta: { title: '购买记录', allowNoAuth: true },
        },
        {
          path: 'home',
          name: 'tgStore.home',
          component: () => import('@/views/tgStore/home.vue'),
          meta: { title: '商城主页', allowNoAuth: true },
        },
      ],
    },
    // 注册抽奖
    {
      path: '/drawLot',
      name: 'drawLot',
      component: () => import('@/views/drawLot/index.vue'),
      meta: { title: '购买记录', allowNoAuth: true },
    },
    // 签到活动
    {
      path: '/signAct',
      name: 'signAct',
      component: () => import('@/views/signAct/index.vue'),
      meta: { suspend: 3 },
    },
    // 代金券活动
    {
      path: '/voucherAct',
      name: 'voucherAct',
      component: () => import('@/views/voucherAct/index.vue'),
      meta: { title: '代金券活动', keepAlive: true },
    },
    // 代金券活动 - 领取记录
    {
      path: '/voucherRecord',
      name: 'voucherRecord',
      component: () => import('@/views/voucherAct/record.vue'),
      meta: { title: '领取记录' },
    },
    // 限时福利
    {
      path: '/limitedAct',
      name: 'limitedAct',
      component: () => import('@/views/limitedAct/index.vue'),
      meta: { suspend: 4 },
    },
    // 53 客服
    {
      path: '/service',
      name: 'service',
      component: () => import('@/views/service/index.vue'),
      meta: { title: '变态猫—996游戏推荐福利官' },
    },
    // 没有匹配的路由时，跳转到游戏圈中心页
    { path: '*', redirect: '/gameCircleCenter/home' },
  ],
});

// 判断是否为微信授权页跳转链接
const isAuthorizationRedirectUrl = () => {
  try {
    const search = decodeURIComponent(window.location.search);
    const flag = search.indexOf('code') === -1 ? false : true;
    return flag;
  } catch (error) {
    console.log('授权页', error);
    return false;
  }
};

// 处理微信授权页跳转链接, 获取code
const handleLocationSearch = () => {
  try {
    let search = decodeURIComponent(window.location.search);
    search = search.slice(1).split('&state=');
    let obj = {
      code: search[0].split('=')[1],
      state: search[1],
    };
    return obj;
  } catch (e) {
    console.log('auth', e);
    return {};
  }
};

// 处理微信授权页跳转链接, 获取路由name与query
const handleState = (state) => {
  const stateArr = state.split('_HM_');
  let path = {},
    queryObj = {};
  path['name'] = stateArr[0];
  for (let i = 1; i < stateArr.length; i++) {
    let queryItem = stateArr[i].split('=');
    queryObj[queryItem[0]] = queryItem[1];
  }
  path['query'] = queryObj;
  return path;
};

// 将query对象转成"_HM"拼接的字符串
const handleQuery = (query) => {
  let queryArr = [];
  for (let key in query) {
    queryArr.push(`${key}=${query[key]}`);
  }
  return queryArr.join('_HM_');
};

// 以下页面不需要获取用户信息
const NO_USERINFO_LIST = ['activity.vouchers', 'activity.seckill'];
// 以下页面不需要授权
const NO_AUTHORIZATION_LIST = ['activity.authorization', 'activity.seckill'];
// 以下页面不走微信逻辑
const NO_VX_LIST = ['preview.996', 'preview.home', 'preview.details'];

// 2021.11.18新增微信授权登录埋点
const wxPoint = [
  { type: 1, from: 'gameCenter.home' },
  { type: 2, from: 'giftCenter.home' },
  { type: 3, from: 'gameCircle.home' },
  { type: 3, from: 'gameCircle.details' },
];

router.beforeEach(async (to, from, next) => {
  if (NO_VX_LIST.includes(to.name)) {
    next();
    return;
  }

  if (!isWeiXin() && to.meta.allowNoAuth) {
    next();
    return;
  }

  const { userInfo } = store.state.account;
  try {
    if (userInfo) {
      // vuex中存在用户信息1
      next();
    } else {
      if (isAuthorizationRedirectUrl()) {
        // 处理微信授权页跳转url获取code、pathName、pathQuery，并使用处理过的url替换历史记录中的url
        // ?code=071ooabY1ZDee01tmA9Y1tsUaY1ooabb&state=gameCircle.home_HM_circleId%3D3
        const { code, state } = handleLocationSearch();
        const _url = window.location.protocol + '//' + window.location.host + '/#/gameCenter/home';
        window.history.replaceState({}, 0, _url);
        // 通过code获取access_token，本地缓存跳转路由、access_token、授权时间
        const fromPath = state.split('_HM_')[0];
        const fromFilter = wxPoint.filter((m) => m.from === fromPath)[0];
        const wxObj = fromFilter ? { code, type: fromFilter.type } : { code };
        let authRes = await getAccessToken(wxObj);
        localStorage.setItem('redirectRoute', JSON.stringify(handleState(state)));
        localStorage.setItem('access_token', authRes.data.token);
        localStorage.setItem('timestamp', moment().unix());
        // 判断授权页跳转url中state是否存在
        if (state) {
          const pathObj = handleState(state) || {};
          next({ name: pathObj.name, query: pathObj.query, replace: true });
        } else {
          next({ name: 'gameCenter.home', replace: true });
        }
        return;
      }
      const accessToken = localStorage.getItem('access_token');
      if (accessToken) {
        // 如果本地缓存中有access_token
        try {
          if (!NO_USERINFO_LIST.includes(to.name)) {
            const r = await getUserInfo();
            store.commit('account/CHANGE_USERINFO', r.data);
            next();
          } else {
            next();
          }
        } catch (error) {
          // 如果通过access_token获取用户信息失败（access_token过期）则清空缓存，重新走授权拿到新的token
          console.error('token error');
          localStorage.clear();
          next();
          // next({ name: 'gameCenter.home', replace: true });
        }
      } else {
        if (NO_AUTHORIZATION_LIST.includes(to.name)) {
          next();
          return;
        }
        // 如果本地缓存中没有accessToken,则需要通过微信授权拿到这个access_token
        let redirect_uri = encodeURIComponent(window.location.origin);
        // 如果本地缓存没有access_token, 则去开放平台拿code，通过code获取access_token
        const query = to.query ? handleQuery(to.query) : '';
        const state = `${to.name}_HM_${query}`;
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
      }
    }
  } catch (error) {
    console.log('未知异常', error);
  }
});

router.afterEach((to, from) => {
  if (NO_VX_LIST.includes(to.name)) {
    return;
  }
  if (NO_AUTHORIZATION_LIST.includes(from.name)) {
    // next();
    return;
  }

  if (!isWeiXin() && to.meta.allowNoAuth) {
    // next();
    return;
  }

  // 同一个url调用一次config接口注入权限验证配置
  wxConfig();
  if (!NO_USERINFO_LIST.includes(to.name)) {
    // 用户论坛封禁需要在切换页面的时候获取用户信息
    // store.dispatch('account/getUserInfo');
    // const { userInfo } = store.state.account;
    // const prohibition = userInfo.prohibition;
    // if (prohibition.state_type == 1) {
    //   let warnMsg = `您因违规操作而被封号\n 封号时间：${
    //     prohibition.time_type == 1 ? '永久' : prohibition.start_time + '~' + prohibition.end_time
    //   }`;
    //   Dialog.alert({
    //     title: '温馨提示',
    //     message: warnMsg,
    //   }).then(() => {
    //     wx.closeWindow();
    //   });
    //   return;
    // }
  }
  // 添加白名单，白名单中的页面属于论坛页面，其余都属于平台页面
  const WHITE_LIST = ['gameCircle.home', 'gameCircle.details']; // 游戏圈
  let deviceType = 3; // 默认是电脑
  if (getDevice().Mobile) {
    deviceType = 1;
  }
  if (getDevice().iPad) {
    deviceType = 2;
  }
  if (
    WHITE_LIST.find((item) => {
      return to.name == item;
    })
  ) {
    let forumHasLogin = sessionStorage.getItem('forumHasLogin');
    if (forumHasLogin) return;
    sessionStorage.setItem('forumHasLogin', true);
    // 论坛上报
    reportLoginForum({ type: deviceType });
  } else {
    let platHasLogin = sessionStorage.getItem('platHasLogin');
    if (platHasLogin) return;
    sessionStorage.setItem('platHasLogin', true);
    // 平台上报
    reportLoginPlatform({ type: deviceType });
  }

  // 未注册论坛用户进入注册页
  // if (
  //   userInfo.forum_user_id == 0 &&
  //   to.name != 'account.registeredAccount' &&
  //   !WHITE_LIST.find(item => {
  //     return to.name.includes(item);
  //   })
  // ) {
  //   localStorage.setItem(
  //     'redirectRoute',
  //     JSON.stringify({
  //       name: to.name,
  //       query: to.query,
  //     }),
  //   );
  //   router.replace({ name: 'account.registeredAccount' }).catch(err => err);
  // }
  // ios复制链接问题
  // if (getDevice().ios) {
  //   setTimeout(() => {
  //     const href = window.location.href;
  //     window.location.href = href;
  //   }, 200);
  // }
  // 最后一次登录数据上报
  // if (
  //   !WHITE_LIST.find(item => {
  //     return to.name.includes(item);
  //   })
  // ) {
  //   // 论坛页面
  //   reportLastVisitTime({ is_visit_forum: 1 });
  // } else {
  //   reportLastVisitTime();
  // }
});

export default router;
